import { authFetch } from "../utils/authFetch";
import type { AuthedSessionResponse } from "../models/session";

type EnrollBiometricsResponse = {
  enrolled: boolean;
  deviceId: string;
};

type DeleteBiometricsResponse = {
  revoked: boolean;
};

type EnrolledDevice = {
  deviceId: string;
  enrolledAt: string;
};

type BiometricStatusResponse = {
  enrolled: boolean;
  devices: EnrolledDevice[];
};

type BiometricChallengeResponse = {
  challengeId: string;
  challenge: string;
  expiresAt: string;
};

export const enrollBiometrics = (publicKey: string, token?: string) =>
  authFetch<EnrollBiometricsResponse>("/auth/biometric/enroll", {
    method: "POST",
    token,
    body: { publicKey },
  });

export const deleteBiometrics = (token?: string, allDevices: boolean = false) =>
  authFetch<DeleteBiometricsResponse>(
    `/auth/biometric${allDevices ? "?all=true" : ""}`,
    {
      method: "DELETE",
      token,
    },
  );

export const getBiometricStatus = (token?: string) =>
  authFetch<BiometricStatusResponse>("/auth/biometric/status", {
    token,
  });

export const getBiometricChallenge = () =>
  authFetch<BiometricChallengeResponse>("/auth/biometric/challenge");

export const loginWithBiometrics = (challengeId: string, signature: string) =>
  authFetch<AuthedSessionResponse>("/auth/biometric/verify", {
    method: "POST",
    body: { challengeId, signature },
  });
